module.exports = __webpack_public_path__ + "static/media/NS.928fc204.png";